export const NumberOrderIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2504_3658)">
      <path
        d="M15 6.75H8.25C7.42157 6.75 6.75 7.42157 6.75 8.25V15C6.75 15.8284 7.42157 16.5 8.25 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15V8.25C16.5 7.42157 15.8284 6.75 15 6.75Z"
        stroke="#6C6F71"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 11.25H3C2.60218 11.25 2.22064 11.092 1.93934 10.8107C1.65804 10.5294 1.5 10.1478 1.5 9.75V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H9.75C10.1478 1.5 10.5294 1.65804 10.8107 1.93934C11.092 2.22064 11.25 2.60218 11.25 3V3.75"
        stroke="#6C6F71"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2504_3658">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const OrderCalender = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.25 6.75C2.25 5.09314 3.59314 3.75 5.25 3.75H12.75C14.4068 3.75 15.75 5.09314 15.75 6.75V12.75C15.75 14.4068 14.4068 15.75 12.75 15.75H5.25C3.59314 15.75 2.25 14.4068 2.25 12.75V6.75ZM5.25 5.25C4.42157 5.25 3.75 5.92157 3.75 6.75V12.75C3.75 13.5785 4.42157 14.25 5.25 14.25H12.75C13.5785 14.25 14.25 13.5785 14.25 12.75V6.75C14.25 5.92157 13.5785 5.25 12.75 5.25H5.25Z"
      fill="#6C6F71"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 2.25C6.41421 2.25 6.75 2.58579 6.75 3V4.5C6.75 4.91421 6.41421 5.25 6 5.25C5.58579 5.25 5.25 4.91421 5.25 4.5V3C5.25 2.58579 5.58579 2.25 6 2.25Z"
      fill="#6C6F71"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V4.5C12.75 4.91421 12.4142 5.25 12 5.25C11.5858 5.25 11.25 4.91421 11.25 4.5V3C11.25 2.58579 11.5858 2.25 12 2.25Z"
      fill="#6C6F71"
    />
    <path
      d="M6.75 7.5C6.75 7.91422 6.41421 8.25 6 8.25C5.58579 8.25 5.25 7.91422 5.25 7.5C5.25 7.08579 5.58579 6.75 6 6.75C6.41421 6.75 6.75 7.08579 6.75 7.5Z"
      fill="#6C6F71"
    />
    <path
      d="M9.75 7.5C9.75 7.91422 9.41422 8.25 9 8.25C8.58578 8.25 8.25 7.91422 8.25 7.5C8.25 7.08579 8.58578 6.75 9 6.75C9.41422 6.75 9.75 7.08579 9.75 7.5Z"
      fill="#6C6F71"
    />
    <path
      d="M12.75 7.5C12.75 7.91422 12.4142 8.25 12 8.25C11.5858 8.25 11.25 7.91422 11.25 7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5Z"
      fill="#6C6F71"
    />
    <path
      d="M6.75 10.5C6.75 10.9142 6.41421 11.25 6 11.25C5.58579 11.25 5.25 10.9142 5.25 10.5C5.25 10.0858 5.58579 9.75 6 9.75C6.41421 9.75 6.75 10.0858 6.75 10.5Z"
      fill="#6C6F71"
    />
  </svg>
);
export const InitialIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2504_3701)">
      <rect width="18" height="18" rx="2" fill="#2977CC" />
      <path
        d="M5.996 13V4.06H9.152C9.744 4.06 10.264 4.172 10.712 4.396C11.16 4.62 11.508 4.94 11.756 5.356C12.012 5.772 12.14 6.26 12.14 6.82C12.14 7.452 11.98 7.988 11.66 8.428C11.34 8.868 10.908 9.184 10.364 9.376L12.44 13H11.072L8.888 9.124L9.668 9.58H7.172V13H5.996ZM7.172 8.5H9.188C9.54 8.5 9.848 8.432 10.112 8.296C10.376 8.16 10.58 7.964 10.724 7.708C10.876 7.452 10.952 7.156 10.952 6.82C10.952 6.476 10.876 6.18 10.724 5.932C10.58 5.676 10.376 5.48 10.112 5.344C9.848 5.208 9.54 5.14 9.188 5.14H7.172V8.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2504_3701">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const AttachmentIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2504_4321)">
      <path
        d="M8.42236 2.80631C9.85973 0.562452 12.8408 -0.0892833 15.0808 1.35063C17.3208 2.79053 17.9713 5.77682 16.5339 8.02071L15.286 7.21848C16.2811 5.66502 15.8307 3.59759 14.2799 2.60074C12.7293 1.60388 10.6654 2.05508 9.67029 3.60853L8.42236 2.80631Z"
        fill="#6C6F71"
      />
      <path
        d="M9.66963 3.60885L3.46293 13.2979C2.80053 14.3333 3.10086 15.7104 4.13431 16.3746C5.16822 17.039 6.54428 16.7382 7.20779 15.7027L8.80956 13.2026L8.80854 13.2019L12.8126 6.95133L12.8136 6.95201C13.1452 6.43418 12.9951 5.74507 12.4782 5.4128C11.9613 5.08052 11.2734 5.23092 10.9416 5.74873L10.9406 5.7481L7.76119 10.7987C7.56669 11.1023 7.16311 11.1904 6.85975 10.9954L6.71029 10.8993C6.40697 10.7044 6.31875 10.3001 6.51325 9.99647L9.69277 4.94583L9.69372 4.94646C10.4677 3.73828 12.0729 3.38737 13.279 4.16269C14.4851 4.93802 14.8354 6.54602 14.0615 7.75424L14.0605 7.75363L12.4593 10.2532L12.4605 10.254L8.45612 16.5051C7.35019 18.2309 5.05648 18.732 3.33335 17.6246C1.61016 16.5172 1.10976 14.2204 2.21567 12.4944L8.4217 2.80664L9.66963 3.60885Z"
        fill="#6C6F71"
      />
      <path
        d="M10.428 16.0096C10.1247 15.8146 10.0365 15.4104 10.231 15.1068L15.2842 7.21826L16.5322 8.0205L11.4789 15.909C11.2844 16.2126 10.8808 16.3007 10.5775 16.1057L10.428 16.0096Z"
        fill="#6C6F71"
      />
    </g>
    <defs>
      <clipPath id="clip0_2504_4321">
        <rect width="18.8967" height="18.8967" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TextIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="30"
      height="30"
      rx="3"
      fill="white"
      stroke="#EAF1FA"
      stroke-width="2"
    />
    <path
      d="M14.2001 16.0002C14.2001 16.3562 14.3057 16.7042 14.5035 17.0002C14.7012 17.2962 14.9824 17.5269 15.3113 17.6632C15.6402 17.7994 16.0021 17.8351 16.3513 17.7656C16.7004 17.6962 17.0212 17.5247 17.2729 17.273C17.5246 17.0213 17.6961 16.7005 17.7655 16.3514C17.835 16.0022 17.7993 15.6403 17.6631 15.3114C17.5268 14.9825 17.2961 14.7013 17.0001 14.5035C16.7041 14.3058 16.3561 14.2002 16.0001 14.2002C15.5227 14.2002 15.0649 14.3898 14.7273 14.7274C14.3897 15.065 14.2001 15.5228 14.2001 16.0002ZM7.6001 16.0002C7.6001 16.3562 7.70567 16.7042 7.90345 17.0002C8.10124 17.2962 8.38236 17.5269 8.71127 17.6632C9.04017 17.7994 9.40209 17.8351 9.75126 17.7656C10.1004 17.6962 10.4212 17.5247 10.6729 17.273C10.9246 17.0213 11.0961 16.7005 11.1655 16.3514C11.235 16.0022 11.1993 15.6403 11.0631 15.3114C10.9268 14.9825 10.6961 14.7013 10.4001 14.5035C10.1041 14.3058 9.7561 14.2002 9.4001 14.2002C8.92271 14.2002 8.46487 14.3898 8.12731 14.7274C7.78974 15.065 7.6001 15.5228 7.6001 16.0002ZM20.8001 16.0002C20.8001 16.3562 20.9057 16.7042 21.1035 17.0002C21.3012 17.2962 21.5824 17.5269 21.9113 17.6632C22.2402 17.7994 22.6021 17.8351 22.9513 17.7656C23.3004 17.6962 23.6212 17.5247 23.8729 17.273C24.1246 17.0213 24.2961 16.7005 24.3655 16.3514C24.435 16.0022 24.3993 15.6403 24.2631 15.3114C24.1268 14.9825 23.8961 14.7013 23.6001 14.5035C23.3041 14.3058 22.9561 14.2002 22.6001 14.2002C22.1227 14.2002 21.6649 14.3898 21.3273 14.7274C20.9897 15.065 20.8001 15.5228 20.8001 16.0002Z"
      fill="black"
    />
  </svg>
);
export const ImageUplaodIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2621_7404)">
      <path
        d="M28.5 0H7.5C5.51161 0.00238179 3.60534 0.793323 2.19933 2.19933C0.793323 3.60534 0.00238179 5.51161 0 7.5L0 28.5C0.00238179 30.4884 0.793323 32.3947 2.19933 33.8007C3.60534 35.2067 5.51161 35.9976 7.5 36H28.5C30.4884 35.9976 32.3947 35.2067 33.8007 33.8007C35.2067 32.3947 35.9976 30.4884 36 28.5V7.5C35.9976 5.51161 35.2067 3.60534 33.8007 2.19933C32.3947 0.793323 30.4884 0.00238179 28.5 0ZM33 28.5C33 29.6935 32.5259 30.8381 31.682 31.682C30.8381 32.5259 29.6935 33 28.5 33H7.5C6.30653 33 5.16193 32.5259 4.31802 31.682C3.47411 30.8381 3 29.6935 3 28.5V7.5C3 6.30653 3.47411 5.16193 4.31802 4.31802C5.16193 3.47411 6.30653 3 7.5 3H28.5C29.6935 3 30.8381 3.47411 31.682 4.31802C32.5259 5.16193 33 6.30653 33 7.5V28.5Z"
        fill="#232323"
      />
      <path
        d="M10.5 15C11.39 15 12.26 14.7361 13.0001 14.2416C13.7401 13.7471 14.3169 13.0443 14.6575 12.2221C14.9981 11.3998 15.0872 10.495 14.9135 9.6221C14.7399 8.74918 14.3113 7.94736 13.682 7.31802C13.0526 6.68868 12.2508 6.2601 11.3779 6.08647C10.505 5.91283 9.60019 6.00195 8.77792 6.34254C7.95566 6.68314 7.25285 7.25991 6.75839 7.99994C6.26392 8.73996 6 9.60999 6 10.5C6 11.6935 6.47411 12.8381 7.31802 13.682C8.16193 14.5259 9.30653 15 10.5 15ZM10.5 9C10.7967 9 11.0867 9.08798 11.3334 9.2528C11.58 9.41762 11.7723 9.65189 11.8858 9.92598C11.9994 10.2001 12.0291 10.5017 11.9712 10.7926C11.9133 11.0836 11.7704 11.3509 11.5607 11.5607C11.3509 11.7704 11.0836 11.9133 10.7926 11.9712C10.5017 12.0291 10.2001 11.9994 9.92598 11.8858C9.65189 11.7723 9.41762 11.58 9.2528 11.3334C9.08797 11.0867 9 10.7967 9 10.5C9 10.1022 9.15804 9.72065 9.43934 9.43934C9.72064 9.15804 10.1022 9 10.5 9Z"
        fill="#232323"
      />
      <path
        d="M25.0604 15.4395C24.9178 15.2908 24.7448 15.1746 24.5533 15.0988C24.3617 15.0229 24.1561 14.9892 23.9504 15C23.745 15.0072 23.5433 15.0563 23.3576 15.1443C23.1719 15.2323 23.0061 15.3572 22.8704 15.5115L18.3254 20.7L14.5604 16.9335C14.2791 16.6523 13.8976 16.4943 13.4999 16.4943C13.1021 16.4943 12.7207 16.6523 12.4394 16.9335L6.43938 22.9335C6.29611 23.0719 6.18184 23.2374 6.10323 23.4204C6.02461 23.6034 5.98323 23.8002 5.9815 23.9994C5.97977 24.1986 6.01772 24.3961 6.09314 24.5804C6.16857 24.7648 6.27995 24.9323 6.42078 25.0731C6.56162 25.2139 6.7291 25.3253 6.91345 25.4007C7.09779 25.4762 7.29531 25.5141 7.49448 25.5124C7.69365 25.5107 7.89048 25.4693 8.07348 25.3907C8.25649 25.312 8.42201 25.1978 8.56038 25.0545L13.4999 20.121L16.3499 22.971L12.3704 27.5115C12.1082 27.8111 11.9758 28.2025 12.0022 28.5997C12.0287 28.9969 12.2118 29.3673 12.5114 29.6295C12.8109 29.8917 13.2024 30.0241 13.5996 29.9977C13.9968 29.9712 14.3672 29.7881 14.6294 29.4885L19.4564 23.9715H19.4654L19.4759 23.955L24.0734 18.705L27.4394 22.071C27.7223 22.3442 28.1012 22.4954 28.4945 22.492C28.8878 22.4886 29.264 22.3308 29.5421 22.0527C29.8202 21.7746 29.978 21.3984 29.9814 21.0051C29.9848 20.6118 29.8336 20.2329 29.5604 19.95L25.0604 15.4395Z"
        fill="#232323"
      />
    </g>
    <defs>
      <clipPath id="clip0_2621_7404">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const MessaageRightIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="6" fill="#EAF1FA" />
    <path
      d="M25 16.5C25 14.8189 24.5015 13.1755 23.5675 11.7777C22.6335 10.3798 21.306 9.29037 19.7528 8.64703C18.1996 8.00368 16.4906 7.83535 14.8417 8.16333C13.1929 8.4913 11.6783 9.30085 10.4896 10.4896C9.30085 11.6783 8.4913 13.1929 8.16333 14.8417C7.83535 16.4906 8.00368 18.1996 8.64703 19.7528C9.29037 21.306 10.3798 22.6335 11.7777 23.5675C13.1755 24.5015 14.8189 25 16.5 25C17.6165 25.0009 18.7222 24.7817 19.7539 24.3548C20.7856 23.928 21.723 23.3019 22.5125 22.5125C23.3019 21.723 23.928 20.7856 24.3548 19.7539C24.7817 18.7222 25.0009 17.6165 25 16.5ZM10 16.5C10 15.2144 10.3812 13.9577 11.0954 12.8888C11.8097 11.8199 12.8248 10.9868 14.0126 10.4948C15.2003 10.0028 16.5072 9.87409 17.7681 10.1249C19.029 10.3757 20.1872 10.9948 21.0962 11.9038C22.0052 12.8128 22.6243 13.971 22.8751 15.2319C23.1259 16.4928 22.9972 17.7997 22.5052 18.9874C22.0132 20.1752 21.1801 21.1903 20.1112 21.9046C19.0423 22.6188 17.7856 23 16.5 23C15.6459 23.0017 14.7999 22.8348 14.0105 22.5087C13.2211 22.1827 12.5039 21.7039 11.9 21.1C11.2961 20.4961 10.8173 19.7789 10.4913 18.9895C10.1652 18.2001 9.99829 17.3541 10 16.5ZM20.75 16.25C20.9326 16.0637 21.0342 15.8129 21.0329 15.5521C21.0316 15.2912 20.9274 15.0415 20.743 14.857C20.5585 14.6726 20.3088 14.5684 20.0479 14.5671C19.7871 14.5658 19.5363 14.6674 19.35 14.85L16.5 17.7L13.65 14.85C13.4637 14.6674 13.2129 14.5658 12.9521 14.5671C12.6912 14.5684 12.4415 14.6726 12.257 14.857C12.0726 15.0415 11.9684 15.2912 11.9671 15.5521C11.9658 15.8129 12.0674 16.0637 12.25 16.25L15.1 19.1C15.2855 19.2899 15.5072 19.4409 15.7519 19.5439C15.9966 19.647 16.2595 19.7001 16.525 19.7001C16.7905 19.7001 17.0534 19.647 17.2981 19.5439C17.5428 19.4409 17.7645 19.2899 17.95 19.1L20.75 16.25Z"
      fill="#2977CC"
    />
  </svg>
);
export const MessaageArrowUpIcon = () => (
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_2)">
<path d="M26 0H6C2.68629 0 0 2.68629 0 6V26C0 29.3137 2.68629 32 6 32H26C29.3137 32 32 29.3137 32 26V6C32 2.68629 29.3137 0 26 0Z" fill="#EAF1FA"/>
<path d="M8 16.5C8 18.1811 8.4985 19.8245 9.4325 21.2223C10.3665 22.6202 11.694 23.7096 13.2472 24.353C14.8004 24.9963 16.5094 25.1647 18.1583 24.8367C19.8071 24.5087 21.3217 23.6992 22.5104 22.5104C23.6992 21.3217 24.5087 19.8071 24.8367 18.1583C25.1647 16.5094 24.9963 14.8004 24.353 13.2472C23.7096 11.694 22.6202 10.3665 21.2223 9.4325C19.8245 8.4985 18.1811 8 16.5 8C15.3835 7.9991 14.2778 8.2183 13.2461 8.6452C12.2144 9.072 11.277 9.6981 10.4875 10.4875C9.6981 11.277 9.072 12.2144 8.6452 13.2461C8.2183 14.2778 7.9991 15.3835 8 16.5ZM23 16.5C23 17.7856 22.6188 19.0423 21.9046 20.1112C21.1903 21.1801 20.1752 22.0132 18.9874 22.5052C17.7997 22.9972 16.4928 23.1259 15.2319 22.8751C13.971 22.6243 12.8128 22.0052 11.9038 21.0962C10.9948 20.1872 10.3757 19.029 10.1249 17.7681C9.8741 16.5072 10.0028 15.2003 10.4948 14.0126C10.9868 12.8248 11.8199 11.8097 12.8888 11.0954C13.9577 10.3812 15.2144 10 16.5 10C17.3541 9.9983 18.2001 10.1652 18.9895 10.4913C19.7789 10.8173 20.4961 11.2961 21.1 11.9C21.7039 12.5039 22.1827 13.2211 22.5087 14.0105C22.8348 14.7999 23.0017 15.6459 23 16.5ZM12.25 16.75C12.0674 16.9363 11.9658 17.1871 11.9671 17.4479C11.9684 17.7088 12.0726 17.9585 12.257 18.143C12.4415 18.3274 12.6912 18.4316 12.9521 18.4329C13.2129 18.4342 13.4637 18.3326 13.65 18.15L16.5 15.3L19.35 18.15C19.5363 18.3326 19.7871 18.4342 20.0479 18.4329C20.3088 18.4316 20.5585 18.3274 20.743 18.143C20.9274 17.9585 21.0316 17.7088 21.0329 17.4479C21.0342 17.1871 20.9326 16.9363 20.75 16.75L17.9 13.9C17.7145 13.7101 17.4928 13.5591 17.2481 13.4561C17.0034 13.353 16.7405 13.2999 16.475 13.2999C16.2095 13.2999 15.9466 13.353 15.7019 13.4561C15.4572 13.5591 15.2355 13.7101 15.05 13.9L12.25 16.75Z" fill="#2977CC"/>
</g>
<defs>
<clipPath id="clip0_1_2">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
);